document.addEventListener('DOMContentLoaded', function () {

  // Sticky filter bar is only compataible with non-sticky header + mega menu-based navigation
  if (!document.querySelector('sticky-header') && document.querySelector('header .mega-menu')) {
    window.addEventListener('scroll', function () {
      // Use const for elements that are not going to be reassigned
      const header = document.querySelector('header');
      const element = document.querySelector('aside.facets-wrapper--sticky');

      // Check if both the header and the target element exist before proceeding
      if (header && element) {
        const menuHeight = header.offsetHeight; // Use const because menuHeight is not reassigned
        // Check the scroll position and adjust the element's style accordingly
        if (window.scrollY > menuHeight) {
          element.style.position = 'sticky';
          element.style.top = '0px';
        } else {
          element.style.position = 'unset'; // Reset back to original when scrolling up
        }
      }
    });

    // Function to extract URI query parameters
    function getQueryParams() {
      const params = {};
      const queryString = window.location.search.substring(1);
      const pairs = queryString.split('&');

      for (let pair of pairs) {
        if (pair) {
          const [key, value] = pair.split('=');
          params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
      }
      return params;
    }

    // Show order history and hide Yotpo rewards on the customer account page
    const queryParams = getQueryParams();
    if (queryParams.showOrders === 'true') {
      const customerOrders = document.querySelectorAll('.customer > div.orders');
      customerOrders.forEach(function(element) {
        element.classList.remove('hidden');
      });
      const yotpoContainers = document.querySelectorAll('.yotpo-widgets');
      yotpoContainers.forEach(function(element) {
        element.classList.add('hidden');
      });
    }
  }

  function positionQuickAdds() {
    // Select all .card elements
    const cards = document.querySelectorAll('.card-wrapper.product-card-wrapper');

    cards.forEach(card => {
      const cardMedia = card.querySelector('.card__media');
      const quickAdd = card.querySelector('.quick-add');

      if (cardMedia && quickAdd) {
        // Center .quick-add within .card__media
        quickAdd.style.position = 'absolute';
        quickAdd.style.left = `${cardMedia.offsetWidth / 2}px`;
        quickAdd.style.top = `${cardMedia.offsetHeight / 2}px`;
        quickAdd.style.transform = 'translate(-50%, -50%)';
      }
    });
  }

  // Initial positioning
  positionQuickAdds();

  // Reposition on window resize in case .card__media sizes change
  window.addEventListener('resize', positionQuickAdds);

  /**
  * Sarah Flint
  * 
  * Detect and open child mega menu elements on hover for non-mobile screens
  */
  let headerMenuItems = document.querySelector('header .header__inline-menu').querySelectorAll('.header__menu-item');
  headerMenuItems.forEach(menuItem => {
    menuItem.addEventListener('click', (event) => {
      let activeItemWrapper = menuItem.parentNode;

      if (activeItemWrapper.classList.contains('mega-menu')) {
        event.preventDefault();
      }
    });

    menuItem.addEventListener('mouseover', () => {
      let activeItemWrapper = menuItem.parentNode;

      if (activeItemWrapper.classList.contains('mega-menu')) {
        if (activeItemWrapper.getAttribute('open') === 'true') {
          return;
        }
      }

      let megaMenuItems = activeItemWrapper.closest('header .header__inline-menu').querySelectorAll('.mega-menu');
      megaMenuItems.forEach(megaMenuItem => {
        if (megaMenuItem.id !== activeItemWrapper.id) {
          megaMenuItem.removeAttribute('open');
        }
      });

      if (activeItemWrapper.classList.contains('mega-menu')) {
        activeItemWrapper.setAttribute('open', true);

        activeItemWrapper.closest('.header-wrapper').addEventListener('mouseleave', () => {
          activeItemWrapper.removeAttribute('open');
        });
      }
    });
  });
});